import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, CheckCircle2, AlertCircle } from "lucide-react";
import usePincodeLookup from "@/hooks/usePincodeLookup";

const STATUS_STYLES = {
  error: { input: "border-red-400 focus-visible:ring-red-400", text: "text-red-600", Icon: AlertCircle, icon: "text-red-500" },
  ok: { input: "border-emerald-400 focus-visible:ring-emerald-400", text: "text-emerald-600", Icon: CheckCircle2, icon: "text-emerald-500" },
  loading: { input: "", text: "text-slate-500", Icon: Loader2, icon: "animate-spin text-slate-400" },
  idle: { input: "", text: "text-slate-500", Icon: null, icon: "" },
};

/* Pincode input with India Post auto-resolve. Emits onChange(pincode) per keystroke and onResolved({pincode, city, district, state, isRajasthan}). */
export default function PincodeInput({ value = "", onChange, onResolved, label = "Pincode", required = false, testId = "pincode-input", disabled = false }) {
  const { pin, state, handleInput } = usePincodeLookup({ value, onChange, onResolved });
  const style = STATUS_STYLES[state.status];
  const Icon = style.Icon;
  return (
    <div>
      <Label>{label}{required && " *"}</Label>
      <div className="relative mt-1.5">
        <Input value={pin} onChange={handleInput} placeholder="6-digit pincode (e.g. 302001)" inputMode="numeric" maxLength={6}
          required={required} disabled={disabled} data-testid={testId} className={style.input} />
        {Icon && <Icon className={`absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 ${style.icon}`} />}
      </div>
      {state.message && <div className={`text-xs mt-1 ${style.text}`} data-testid={`${testId}-message`}>{state.message}</div>}
    </div>
  );
}
